export const CookieBot = {
    isPresent: () => {
        return "Cookiebot" in window;
    },
    hasGrantedPermission: () => {
        return Boolean(window.Cookiebot && window.Cookiebot.consent.marketing);
    },
    onConsentChanged: (callback) => {
        window.addEventListener("CookiebotOnAccept", callback);
        window.addEventListener("CookiebotOnDecline", callback);
    },
};
